import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot } from '@angular/router';
import { PerfilService } from '../services/ajs-perfil.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureBetaGuard implements CanActivate, CanActivateChild {
  constructor(private perfil: PerfilService) {}

  async canActivate(
      next: ActivatedRouteSnapshot,
      state: RouterStateSnapshot) {

    if (next.data && next.data.featureName) {
      const features = await this.perfil.getBetaFeatures();
      return features.funcionalidades.some(feature => feature.codigo === next.data.featureName && feature.possuiAcesso);
    }

    return true;
  }

  async canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.canActivate(childRoute, state);
  }

}
